import React from 'react';
import AuthTemplate from '@src/components/Template/Auth';
import { GetServerSideProps } from 'next';
import Meta from '@src/components/Meta';
import { metaInfo } from '@src/data/meta';

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const isLoggedIn = req.cookies['X-AUTH-TOKEN'] ? true : false;
  if (isLoggedIn) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
};

const index = () => {
  const { title, description, ogImage } = metaInfo.auth;
  return (
    <>
      <Meta title={title} description={description} ogImage={ogImage} />
      <AuthTemplate />
    </>
  );
};

export default index;
